import React, { useEffect, useState } from "react";
import { Container, Tab, Tabs } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import EventsAdmin from "./EventsAdmin";
import RegistrationsAdmin from "./RegistrationsAdmin";

export default function EventsManagement() {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(
    () => new URLSearchParams(location.search).get("tab") || "events"
  );

  useEffect(() => {
    const tab = new URLSearchParams(location.search).get("tab");
    if (tab) setActiveTab(tab);
  }, [location.search]);

  return (
    <Container fluid className="py-4">
      <div className="mb-3">
        <h3 className="mb-1">Evenements</h3>
        <div className="text-muted">
          Creez les evenements et suivez les inscriptions depuis le meme espace.
        </div>
      </div>

      <Tabs
        activeKey={activeTab}
        onSelect={(key) => setActiveTab(key || "events")}
        className="mb-3"
      >
        <Tab eventKey="events" title="Evenements">
          <EventsAdmin embedded />
        </Tab>
        <Tab eventKey="registrations" title="Inscriptions">
          <RegistrationsAdmin embedded />
        </Tab>
      </Tabs>
    </Container>
  );
}
